import * as React from 'react';
import clsx from 'clsx';
import { AddonButton } from '../../AddonButton';
import { Base } from '../../Base';
import InputBase from '../InputBase';
import { InputNumberContext, useInputNumberProvider } from './InputNumberContext';
import { jsx as _jsx } from "react/jsx-runtime";
var styles = {
  "root": "InputNumber-root_FoD7q",
  "input": "InputNumber-input_2-_M2"
};
function Root({
  small,
  disabled,
  readOnly,
  children,
  className,
  ...extraProps
}) {
  const context = React.useMemo(() => ({
    variant: small ? 'small' : undefined,
    disabled,
    readOnly
  }), [small, disabled, readOnly]);
  return /*#__PURE__*/_jsx(Base, {
    flex: true,
    flexAlignItemsCenter: true,
    gap: "xsmall",
    className: clsx(styles.root, className),
    ...extraProps,
    children: /*#__PURE__*/_jsx(InputNumberContext.Provider, {
      value: context,
      children: children
    })
  });
}
function Input({
  className,
  ...extraProps
}) {
  const context = useInputNumberProvider();
  return /*#__PURE__*/_jsx(InputBase, {
    type: "number",
    variant: context?.variant,
    disabled: context?.disabled,
    readOnly: context?.readOnly,
    className: clsx(styles.input, className),
    ...extraProps
  });
}
function StepDown({
  disabled,
  children,
  ...extraProps
}) {
  const context = useInputNumberProvider();
  const render = !context?.readOnly;
  return render ? /*#__PURE__*/_jsx(AddonButton, {
    intent: "subtract",
    size: context?.variant === 'small' ? 'xs' : 's',
    disabled: disabled || context?.disabled,
    ...extraProps,
    children: children
  }) : null;
}
function StepUp({
  disabled,
  children,
  ...extraProps
}) {
  const context = useInputNumberProvider();
  const render = !context?.readOnly;
  return render ? /*#__PURE__*/_jsx(AddonButton, {
    intent: "add",
    size: context?.variant === 'small' ? 'xs' : 's',
    disabled: disabled || context?.disabled,
    ...extraProps,
    children: children
  }) : null;
}
Root.displayName = 'InputNumber';
Input.displayName = 'InputNumberInput';
StepDown.displayName = 'InputNumberStepDown';
StepUp.displayName = 'InputNumberStepUp';
export { Root as InputNumber, Input as InputNumberInput, StepDown as InputNumberStepDown, StepUp as InputNumberStepUp };